module.exports = __webpack_public_path__ + "img/feng.188e73fc.png";